import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberRoute } from '../../utils/supportReports';

const RouteMemory = () => {
  const location = useLocation();

  useEffect(() => {
    rememberRoute(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteMemory;
